import React from 'react';
import PropTypes from 'prop-types';
import {StyledSubscriptionInfo} from './StyledSubscriptionInfo';
import SubscriptionStatusMark from '../../SubscriptionsPage/SubscriptionStatusMark';
import {objectHelpers, subscriptionsHelpers} from '../../../../utils/helpers';

const SubscriptionInfo = ({
  data,
  enabledStatus = true,
  ...rest
}) => {
  const gServiceProps = (key, defaultValue = '') => data && data.service ? objectHelpers.getObjProp(data.service, key, defaultValue) : defaultValue;

  const statusCode = subscriptionsHelpers.getSubscriptionStatusCode(data);

  const category = gServiceProps('category');
  const logo = gServiceProps('logo');
  const url = gServiceProps('url');
  const label = subscriptionsHelpers.getSubscriptionName(data);
  const extra = enabledStatus && (
    <SubscriptionStatusMark statusCode={statusCode} />
  );

  return (
    <StyledSubscriptionInfo
      enabledstatus={String(enabledStatus || false)}
      extra={extra}
      description={category}
      name={label}
      logo={logo}
      url={url ? `https://${url}` : undefined}
      {...rest}
    />
  );
}

SubscriptionInfo.propTypes = {
  data: PropTypes.shape({
    service: PropTypes.shape({
      category: PropTypes.string,
      logo: PropTypes.string,
      name: PropTypes.string
    }),
    status: PropTypes.number
  }),
  enabledStatus: PropTypes.bool
}

export default SubscriptionInfo;

